// Sidebar shortcut grid (Bench / Archive / Topics / Add Source).
const SHORTCUTS = [
  { key: 'bench', label: 'Bench', sub: 'Open', wip: true },
  { key: 'archive', label: 'Archive', sub: 'Open' },
  { key: 'topics', label: 'Topics', sub: 'Open' },
  { key: 'add', label: 'Add Source', sub: 'Open' },
];

export default function SidebarShortcuts({ onSelect, enabled = {} }) {
  return (
    <div>
      <div className="font-display text-[11px] font-bold tracking-display-md uppercase text-hxd-muted mb-3">
        Shortcuts
      </div>
      <div className="grid grid-cols-2 gap-2">
        {SHORTCUTS.map((sc) => {
          const isPlaceholder = !!sc.placeholder;
          const isEnabled = !isPlaceholder && !!enabled[sc.key];
          return (
            <button
              key={sc.key}
              type="button"
              disabled={!isEnabled}
              onClick={() => onSelect?.(sc.key)}
              className={
                isEnabled
                  ? 'relative flex flex-col items-start text-left p-3 rounded-[3px] border border-hxd-border bg-white hover:border-hxd-orange transition-colors'
                  : 'relative flex flex-col items-start text-left p-3 rounded-[3px] border border-dashed border-hxd-border-soft bg-hxd-surface cursor-not-allowed opacity-70'
              }
            >
              <span className="text-[13px] font-bold text-hxd-ink">{sc.label}</span>
              <span className="text-[10px] uppercase tracking-display-sm text-hxd-muted mt-1">
                {isEnabled ? 'Open' : sc.sub}
              </span>
              {sc.wip && isEnabled && (
                <span className="absolute top-1.5 right-1.5 font-display text-[8px] font-bold uppercase tracking-display-sm px-1.5 py-0.5 rounded-[2px] bg-hxd-warn/15 text-hxd-warn border border-hxd-warn/40">
                  WIP
                </span>
              )}
              {isPlaceholder && (
                <span className="absolute top-1.5 right-1.5 font-display text-[8px] font-bold uppercase tracking-display-sm px-1.5 py-0.5 rounded-[2px] bg-hxd-muted/15 text-hxd-muted border border-hxd-muted/40">
                  Soon
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
